import { formatSeparateLineItemPerEachInventoryItem } from '../formatSeparateLineItemPerEachInventoryItem'
import { getInventoryItemId } from '../../helpers'

export const formatPercentageSubAllocationLineItems = ({ inventory, values, right, campaignId, currency }) => {
  const billingEvent = right?.billing_event

  const inventoryFilledWithUnitsAndMicroAmount = inventory.map(inventoryItem => {
    const microAmount = inventoryItem.prices[billingEvent] || 0

    const foundSubAllocationItem = right.sub_allocation.find(item => {
      return getInventoryItemId(item) === getInventoryItemId(inventoryItem)
    })

    return {
      ...inventoryItem,
      units: foundSubAllocationItem.allocation,
      microAmount
    }
  })

  const formattedLineItems = formatSeparateLineItemPerEachInventoryItem({
    values,
    formattedInventory: inventoryFilledWithUnitsAndMicroAmount,
    right,
    campaignId,
    currency
  })

  return formattedLineItems
}
